import BaseForm from '../base';
import { LatLongColumnsComponent, ObjectPanelComponent, TwoColumnsComponent } from '../components';
export class AxisNvrForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            {
                label: 'NVR Type',
                data: {
                    values: [
                        {
                            label: 'Axis',
                            value: 'axis'
                        },
                        {
                            label: 'DeepVision',
                            value: 'nx'
                        }
                    ]
                },
                key: 'type',
                type: 'select',
                defaultValue: 'nx',
                validate: {
                    required: true,
                    onlyAvailableItems: true,
                },
                searchFields: ['label', 'value'],
            },
            new LatLongColumnsComponent({ validate: { required: true } }),
            new TwoColumnsComponent({ key: 'localNetwork' }, {
                label: 'Local IP',
                key: 'ip',
                type: 'textfield',
            }, {
                label: 'Local Port',
                key: 'port',
                type: 'number',
            }),
            new TwoColumnsComponent({ key: 'credentials' }, {
                label: 'Username',
                key: 'username',
                type: 'textfield',
            }, {
                label: 'Password',
                key: 'password',
                type: 'customPassword'
            }),
            {
                key: 'deepVisionFields',
                type: 'fieldset',
                label: 'DeepVision Fields',
                conditional: {
                    show: true,
                    when: 'type',
                    eq: 'nx'
                },
                components: [
                    new ObjectPanelComponent({
                        key: 'mqtt',
                        label: 'DeepVision MQTT',
                        collapsed: false,
                        components: [
                            new TwoColumnsComponent({ key: 'mqttCredentials' }, {
                                label: 'Username',
                                key: 'username',
                                type: 'textfield',
                            }, {
                                label: 'Password',
                                key: 'password',
                                type: 'customPassword'
                            }),
                            {
                                label: 'MQTT Port',
                                key: 'port',
                                type: 'number',
                                defaultValue: 1883,
                            },
                        ]
                    }),
                ]
            },
        ];
    }
}
